/* Black Friday 2026 · El Águila y el Cóndor
   Todo se activa solo entre las fechas de la sección "Black Friday" (cabecera).
   Vista previa antes de tiempo: añade ?bf=preview a cualquier URL de la tienda.
   Cuenta atrás de prueba (sin esperar a los últimos días): ?bf=count */
(function () {
  var C = window.BF || {};
  function t(s) { var d = Date.parse(s || ''); return isNaN(d) ? null : d; }
  var start = t(C.start), end = t(C.end), fin = t(C.finalFrom), countFrom = t(C.countFrom);
  var preview = !!C.preview || /[?&]bf=preview/.test(location.search);
  var forceCount = /[?&]bf=count/.test(location.search);
  try {
    if (/[?&]bf=off/.test(location.search)) sessionStorage.removeItem('bfPreview');
    else if (preview || forceCount) sessionStorage.setItem('bfPreview', '1');
    else if (sessionStorage.getItem('bfPreview') === '1') preview = true;
  } catch (e) {}
  if (forceCount) preview = true;

  function active() {
    var n = Date.now();
    if (end && n >= end) return false;
    return preview || (start !== null && end !== null && n >= start);
  }
  /* La cuenta atrás solo se enseña en los últimos días (fecha "Cuenta atrás desde") */
  function counting() {
    if (forceCount) return true;
    return end !== null && (countFrom === null || Date.now() >= countFrom);
  }
  function eur(c) { return (c / 100).toLocaleString('es-ES', { style: 'currency', currency: 'EUR' }); }
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function fmt(ms) {
    if (ms < 0) ms = 0;
    var s = Math.floor(ms / 1000), d = Math.floor(s / 86400);
    s %= 86400;
    var h = Math.floor(s / 3600); s %= 3600;
    var m = Math.floor(s / 60); s %= 60;
    return (d > 0 ? d + 'd ' : '') + pad(h) + ':' + pad(m) + ':' + pad(s);
  }
  function countText() {
    if (counting()) return 'Termina en ' + fmt(end - Date.now());
    return C.datesText || '';
  }
  function dealPct(test) {
    var d = C.deals || [];
    for (var i = 0; i < d.length; i++) if (d[i] && d[i].p > 0 && test(d[i])) return d[i].p;
    return 0;
  }
  function pctFor(cols) {
    var list = (cols || '').split(',');
    if (C.moldHandle && list.indexOf(C.moldHandle) > -1) return C.moldPct;
    return dealPct(function (d) { return list.indexOf(d.c) > -1; }) || C.restPct;
  }
  function pctForHandle(h) {
    if ((C.moldHandles || []).indexOf(h) > -1) return C.moldPct;
    return dealPct(function (d) { return (d.h || []).indexOf(h) > -1; }) || C.restPct;
  }
  function dealLabels() {
    return (C.deals || []).filter(function (d) { return d && d.l; }).map(function (d) { return d.l; });
  }
  function trustLines() {
    var l = [];
    if (C.returnsOn && C.returnsText) l.push(C.returnsText);
    if (C.shipNote) l.push(C.shipNote);
    return l;
  }

  /* 1 · Barra superior */
  function initBar() {
    var bar = document.getElementById('bf-bar');
    if (!bar) return;
    var txt = document.getElementById('bf-bar-text');
    var cnt = document.getElementById('bf-bar-count');
    function tick() {
      if (!active()) {
        bar.hidden = true;
        document.documentElement.classList.remove('bf-on');
        return;
      }
      bar.hidden = false;
      document.documentElement.classList.add('bf-on');
      var n = Date.now();
      var final = fin !== null && n >= fin;
      var text;
      if (C.barText) {
        text = C.barText;
      } else {
        var parts = [final ? (C.finalText || 'Últimas horas de Black Friday') : 'Black Friday'];
        if (C.tagline) parts.push(C.tagline);
        if (C.moldPct) parts.push('Moldavita -' + C.moldPct + ' %');
        parts = parts.concat(dealLabels());
        if (C.restPct) parts.push('Resto de la web -' + C.restPct + ' %');
        if (!final && C.freeShip) parts.push(C.freeShip);
        text = parts.join(' · ');
      }
      if (txt.textContent !== text) txt.textContent = text;
      cnt.textContent = countText();
    }
    tick();
    setInterval(tick, 1000);
  }

  /* 2 · Ficha de producto: precio Black Friday y avisos */
  function renderProduct(el) {
    if (!active()) return;
    var box = el.querySelector('.bf-pdp__deal');
    var price = parseInt(el.getAttribute('data-price'), 10) || 0;
    var compare = parseInt(el.getAttribute('data-compare'), 10) || 0;
    var pct, np, was, how;
    var extra = pctFor(el.getAttribute('data-cols'));
    if (compare > price && price > 0 && !extra) {
      /* Precio ya rebajado en la ficha (precio de comparación) */
      pct = Math.round((compare - price) * 100 / compare);
      np = price; was = compare; how = C.howApp;
    } else {
      /* Descuento automático de Shopify sobre el precio actual: se aplica en la cesta */
      pct = extra;
      np = Math.round(price * (100 - pct) / 100); was = price; how = C.howCart;
    }
    if (box) {
      if (pct > 0 && price > 0) {
        box.querySelector('.bf-pdp__pct').textContent = 'Black Friday -' + pct + ' %';
        box.querySelector('.bf-pdp__price').textContent = eur(np);
        box.querySelector('.bf-pdp__was').textContent = eur(was);
        var h = box.querySelector('.bf-pdp__how');
        if (h) { h.textContent = how || ''; h.hidden = !how; }
        box.hidden = false;
      } else {
        box.hidden = true;
      }
    }
    var tr = el.querySelector('.bf-pdp__trust');
    var lines = trustLines();
    if (tr && lines.length) { tr.textContent = lines.join(' · '); tr.hidden = false; }
  }
  function initProduct() {
    var els = document.querySelectorAll('.bf-pdp');
    for (var i = 0; i < els.length; i++) renderProduct(els[i]);
    if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS) {
      window.subscribe(window.PUB_SUB_EVENTS.variantChange, function (ev) {
        var v = ev && ev.data && ev.data.variant;
        if (!v) return;
        var all = document.querySelectorAll('.bf-pdp');
        for (var j = 0; j < all.length; j++) {
          all[j].setAttribute('data-price', v.price);
          all[j].setAttribute('data-compare', v.compare_at_price || 0);
          var st = all[j].querySelector('.bf-pdp__stock');
          if (st && st.getAttribute('data-variant') !== String(v.id)) st.hidden = true;
          renderProduct(all[j]);
        }
      });
    }
  }

  /* 3 · Carrito lateral: aviso encima del botón de pago */
  function cartNote() {
    if (!active()) return;
    var ctas = document.querySelector('#CartDrawer .cart__ctas');
    if (!ctas || document.getElementById('bf-cart-note')) return;
    var p = document.createElement('p');
    p.id = 'bf-cart-note';
    p.className = 'bf-cart-note';
    var parts = [C.cartText || 'Black Friday: descuentos ya aplicados, sin código'];
    if (C.returnsOn && C.returnsText) parts.push(C.returnsText);
    p.textContent = parts.join(' · ');
    ctas.parentNode.insertBefore(p, ctas);
  }
  /* 7 · Carrito lateral: extras (envoltorio, inciensos, tarjeta regalo) */
  var upCache = {}, upBusy = false;
  function getJSON(u) {
    return fetch(u, { headers: { Accept: 'application/json' } }).then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
  }
  function cartUpsell() {
    if (!active() || upBusy) return;
    var ctas = document.querySelector('#CartDrawer .cart__ctas');
    if (!ctas || document.getElementById('bf-up')) return;
    var handles = (C.upsell || '').split(',').map(function (h) { return h.trim(); }).filter(Boolean);
    if (!handles.length) return;
    upBusy = true;
    Promise.all([getJSON('/cart.js')].concat(handles.map(function (h) {
      if (upCache[h] !== undefined) return Promise.resolve(upCache[h]);
      return getJSON('/products/' + h + '.js').then(function (p) { upCache[h] = p; return p; });
    }))).then(function (res) {
      upBusy = false;
      var cart = res[0], prods = res.slice(1);
      var ctas2 = document.querySelector('#CartDrawer .cart__ctas');
      if (!ctas2 || document.getElementById('bf-up')) return;
      var inCart = {};
      if (cart && cart.items) cart.items.forEach(function (it) { inCart[it.product_id] = 1; });
      var box = document.createElement('div');
      box.id = 'bf-up';
      box.className = 'bf-up';
      var n = 0;
      prods.forEach(function (p) {
        if (!p || !p.available || inCart[p.id]) return;
        var multi = p.gift_card || (p.variants && p.variants.length > 1);
        var v = p.variants[0];
        var row = document.createElement('div');
        row.className = 'bf-up__row';
        var img = p.featured_image ? '<img src="' + p.featured_image + '&width=120" alt="" loading="lazy">' : '';
        var price = multi && p.price_min !== p.price_max ? 'Desde ' + eur(p.price_min) : eur(p.price);
        row.innerHTML = img + '<div class="bf-up__info">' + p.title + '<small>' + price + '</small></div>' +
          (multi ? '<a class="bf-up__btn" href="' + p.url + '">Elegir</a>' : '<button type="button" class="bf-up__btn" data-v="' + v.id + '">Añadir</button>');
        box.appendChild(row);
        n++;
      });
      if (!n) return;
      box.insertAdjacentHTML('afterbegin', '<p class="bf-up__t">' + (C.upsellTitle || 'Completa tu pedido') + '</p>');
      box.addEventListener('click', function (e) {
        var b = e.target.closest('button[data-v]');
        if (!b) return;
        b.disabled = true;
        var cd = document.querySelector('cart-drawer');
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: +b.getAttribute('data-v'), quantity: 1 }], sections: 'cart-drawer,cart-icon-bubble', sections_url: location.pathname })
        }).then(function (r) { return r.json(); }).then(function (data) {
          if (cd && typeof cd.renderContents === 'function' && data.sections) cd.renderContents(data);
          else location.reload();
        }).catch(function () { location.reload(); });
      });
      ctas2.parentNode.insertBefore(box, ctas2);
    });
  }

  function initCart() {
    cartNote();
    cartUpsell();
    var cd = document.querySelector('cart-drawer');
    if (cd && window.MutationObserver) {
      new MutationObserver(function () { cartNote(); cartUpsell(); }).observe(cd, { childList: true, subtree: true });
    }
  }

  /* 4 · Banner de Black Friday en la home */
  function offerLine() {
    var p = [];
    if (C.moldPct) p.push('Moldavita -' + C.moldPct + ' %');
    p = p.concat(dealLabels());
    if (C.restPct) p.push('Resto de la web -' + C.restPct + ' %');
    if (C.tagline) p.push(C.tagline);
    return p.join(' · ');
  }
  function initHero() {
    var hs = document.querySelectorAll('.bf-hero');
    if (!hs.length) return;
    function tick() {
      var on = active(), cd = counting();
      for (var i = 0; i < hs.length; i++) {
        hs[i].hidden = !on;
        if (!on) continue;
        var o = hs[i].querySelector('[data-bf-offer]');
        if (o) o.textContent = offerLine();
        hs[i].classList.toggle('bf-hero--count', cd);
        var c = hs[i].querySelector('[data-bf-count]');
        if (c) { c.textContent = cd ? 'Termina en ' + fmt(end - Date.now()) : ''; c.hidden = !cd; }
      }
    }
    tick();
    setInterval(tick, 1000);
  }

  /* 5 · Etiquetas de descuento: "-15 %" en vez de "Oferta" (fichas y tarjetas) */
  function money(t) {
    var s = (t || '').replace(/[^\d,.]/g, '');
    if (s.indexOf(',') > -1) s = s.replace(/\./g, '').replace(',', '.');
    return parseFloat(s) || 0;
  }
  var saleWord = /oferta|rebaj|sale/i;
  function pctBadges() {
    var ps = document.querySelectorAll('.price--on-sale');
    for (var i = 0; i < ps.length; i++) {
      var reg = ps[i].querySelector('.price__sale .price-item--regular');
      var sale = ps[i].querySelector('.price__sale .price-item--sale');
      if (!reg || !sale) continue;
      var a = money(reg.textContent), b = money(sale.textContent);
      if (!(a > b && b > 0)) continue;
      var label = '-' + Math.round((a - b) * 100 / a) + ' %';
      var own = ps[i].querySelectorAll('.price__badge-sale');
      for (var j = 0; j < own.length; j++) if (own[j].textContent !== label) own[j].textContent = label;
      var card = ps[i].closest('.card-wrapper') || ps[i].closest('.card');
      if (!card) continue;
      var bs = card.querySelectorAll('.card__badge .badge');
      for (var k = 0; k < bs.length; k++) {
        if (bs[k].textContent !== label && saleWord.test(bs[k].textContent)) bs[k].textContent = label;
      }
    }
  }
  function initBadges() {
    pctBadges();
  }

  /* 6 · Precios tachados en todas las tarjetas (colecciones, home, búsqueda, relacionados) */
  function multiFor(h) {
    var ds = C.deals || [];
    for (var i = 0; i < ds.length; i++) if (ds[i] && !ds[i].p && (ds[i].h || []).indexOf(h) > -1) return ds[i];
    return null;
  }
  function imgBadge(card, label) {
    var inner = card.querySelector('.card__inner') || card.querySelector('.card__media');
    if (!inner || inner.querySelector('.bf-img-badge')) return;
    var b = document.createElement('span');
    b.className = 'bf-img-badge';
    b.textContent = label;
    inner.appendChild(b);
    var nb = card.querySelectorAll('.card__badge .badge');
    for (var k = 0; k < nb.length; k++) if (/oferta|rebaj|sale|%/i.test(nb[k].textContent)) nb[k].style.display = 'none';
  }
  function cardCss() {
    if (document.getElementById('bf-card-css')) return;
    var st = document.createElement('style');
    st.id = 'bf-card-css';
    st.textContent = '.card__inner{position:relative}' +
      '.bf-img-badge{position:absolute;top:.8rem;left:.8rem;z-index:3;background:#000;color:#fff;font-size:1.5rem;font-weight:700;letter-spacing:.04rem;line-height:1;padding:.6rem 1rem;border-radius:3px;pointer-events:none}' +
      '.bf-card__note{font-size:1.25rem;color:#1c3d2a}.bf-card s{color:#8a8275}.bf-card strong{color:#000}' +
      '@media(max-width:749px){.bf-img-badge{font-size:1.25rem;padding:.5rem .8rem;top:.6rem;left:.6rem}}';
    document.head.appendChild(st);
  }
  function cardDeals() {
    if (!active()) return;
    cardCss();
    var cards = document.querySelectorAll('.card-wrapper, .predictive-search__list-item, .bf-price-target');
    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      if (card.querySelector('.bf-card')) continue;
      var a = card.matches('a[href*="/products/"]') ? card : card.querySelector('a[href*="/products/"]');
      if (!a) continue;
      var m = (a.getAttribute('href') || '').match(/\/products\/([^\/?#]+)/);
      if (!m) continue;
      var h = decodeURIComponent(m[1]);
      var prices = card.querySelectorAll('.price');
      if (!prices.length) continue;
      var pr = prices[0], box = document.createElement('div');
      if (pr.classList.contains('price--sold-out')) continue; /* agotado: sin etiqueta de oferta */
      box.className = 'bf-card';
      var pct = pctForHandle(h);
      if (pct) {
        var onSale = pr.classList.contains('price--on-sale');
        var was = 0, now = 0;
        if (onSale) {
          var sl = pr.querySelector('.price__sale .price-item--sale');
          was = now = sl ? money(sl.textContent) : 0; /* se tacha el precio actual, no el antiguo */
        } else {
          var rg = pr.querySelector('.price__regular .price-item--regular');
          was = now = rg ? money(rg.textContent) : 0;
        }
        if (!was || !now) continue;
        var fin = Math.round(now * (100 - pct));
        var tot = Math.round(100 - fin / was);
        var from = /desde|a partir/i.test(pr.textContent) ? 'Desde ' : '';
        imgBadge(card, '-' + tot + ' %');
        box.innerHTML = '<s>' + eur(Math.round(was * 100)) + '</s> <strong>' + from + eur(fin) + '</strong>';
      } else {
        var d = multiFor(h);
        if (!d) continue;
        var tag = (d.l || '').match(/\d\s*x\s*\d/i);
        var tl = tag ? tag[0].replace(/\s/g, '') : 'Oferta';
        imgBadge(card, tl);
        box.innerHTML = tag ? '<span class="bf-card__note">Llévate ' + tag[0].replace(/\s/g, '').split(/x/i)[0] + ', paga ' + tag[0].replace(/\s/g, '').split(/x/i)[1] + '</span>' : '';
        box.className += ' bf-card--multi';
        pr.parentNode.insertBefore(box, pr.nextSibling);
        continue;
      }
      pr.parentNode.insertBefore(box, pr);
      for (var j = 0; j < prices.length; j++) prices[j].style.display = 'none';
    }
  }
  function initCards() {
    cardDeals();
    if (!window.MutationObserver) return;
    var t = null;
    new MutationObserver(function (ms) {
      for (var i = 0; i < ms.length; i++) {
        var n = ms[i].target;
        if (n.closest && !n.closest('#bf-bar, .bf-hero, .bf-card')) { clearTimeout(t); t = setTimeout(function () { pctBadges(); cardDeals(); }, 150); return; }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  /* En la página 2, 3… de una colección o búsqueda, Liquid no puede listar los productos de cada oferta:
     se piden aparte (plantilla collection.bfh) y se guardan para la sesión */
  function loadLists(done) {
    if (!/[?&]page=([2-9]|\d\d)/.test(location.search)) return done();
    var key = 'bfLists2', cache = null;
    try { cache = JSON.parse(sessionStorage.getItem(key) || 'null'); } catch (e) {}
    function apply(map) {
      (C.deals || []).forEach(function (d) { if (map[d.c]) d.h = map[d.c]; });
      if (C.moldHandle && map[C.moldHandle]) C.moldHandles = map[C.moldHandle];
      done();
    }
    if (cache) return apply(cache);
    var cols = (C.deals || []).map(function (d) { return d.c; });
    if (C.moldHandle) cols.push(C.moldHandle);
    Promise.all(cols.map(function (c) {
      return fetch('/collections/' + encodeURIComponent(c) + '?view=bfh').then(function (r) { return r.ok ? r.text() : '[]'; })
        .then(function (t) { try { return JSON.parse(t); } catch (e) { return []; } }).catch(function () { return []; });
    })).then(function (res) {
      var map = {};
      cols.forEach(function (c, i) { map[c] = res[i]; });
      try { sessionStorage.setItem(key, JSON.stringify(map)); } catch (e) {}
      apply(map);
    });
  }

  /* Tarjeta regalo: es digital, así que fuera los iconos de envío y el aviso de devoluciones/envíos */
  function giftCard() {
    if (!document.querySelector('recipient-form')) return;
    var st = document.createElement('style');
    st.textContent = '.product__info-container .icon-with-text,.bf-pdp__trust{display:none!important}';
    document.head.appendChild(st);
  }

  function init() { giftCard(); initBar(); initHero(); initProduct(); initCart(); initBadges(); loadLists(initCards); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
